import { type ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';

import Loader from 'components/Loader';
import { useAuth } from 'contexts/AuthContext';

interface RequireAuthProps {
  children: ReactNode;
}

// 비로그인 상태에서 보호된 라우트 진입을 차단하고 /login 으로 리다이렉트.
// 인증 상태 초기 로딩 중에는 Loader 를 보여줘서 깜빡임을 방지한다.
export default function RequireAuth({ children }: RequireAuthProps) {
  const { user, loading, isFirebaseConfigured } = useAuth();
  const location = useLocation();

  if (loading) {
    return <Loader />;
  }

  // Firebase 설정 전에는 가드를 통과시켜 UI 미리보기가 가능하도록 함.
  // 실제 배포 시 .env 가 채워지면 이 분기는 더 이상 타지 않는다.
  if (!isFirebaseConfigured) {
    return <>{children}</>;
  }

  if (!user) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  return <>{children}</>;
}
